import Reveal from "@/components/base/Reveal";
import SectionHeader from "@/components/base/SectionHeader";
import { aboutStats, siteInfo } from "@/mocks/melons";

const PRINCIPLES = [
  { icon: "ri-focus-3-line", title: "先求真，再吃瓜", text: "热点专题先梳理信源与时间线，把「事实」「进展」和「网友观点」分开呈现。" },
  { icon: "ri-hand-heart-line", title: "理性围观，尊重当事人", text: "不传播未经证实的指控，不扩散隐私信息，用尺度守住讨论的底线。" },
  { icon: "ri-refresh-line", title: "跟进反转，及时更新", text: "大瓜不怕翻车，怕不更新。每一条进展与澄清我们都会同步到对应卡片。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeader eyebrow="关于本站" eyebrowIcon="ri-information-line" title="关于「本月大瓜」" />

        <div className="mt-8 grid gap-6 lg:grid-cols-[1.35fr_1fr]">
          <Reveal>
            <div className="flex flex-col gap-5">
              <div className="rounded-2xl border border-background-200 bg-background-50 p-6 shadow-soft">
                <p className="text-sm font-semibold text-primary-700">我们的定位</p>
                <p className="mt-2 text-[15px] leading-relaxed text-foreground-800">
                  {siteInfo.brand}是一个聚焦「全网热点围观与网友讨论」的内容平台。我们不做造谣者，也不当传声筒，
                  而是把本月散落在各平台的热点线索、进展动态、网友评论与群众反应做一次结构化整理，让你在一处就能看清事件脉络、看懂大家的态度。
                </p>
                <p className="mt-3 text-[15px] leading-relaxed text-foreground-800">
                  每期以「月」为单位滚动更新，热搜榜保持实时，焦点专题持续跟进反转，评论区则由你和我共同构成真实的围观现场。
                </p>
              </div>

              <div className="grid gap-5 sm:grid-cols-3">
                {aboutStats.map((s) => (
                  <div key={s.label} className="rounded-2xl border border-background-200 bg-background-50 p-5 text-center shadow-soft">
                    <p className="font-heading text-3xl text-primary-600">{s.value}</p>
                    <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex flex-col gap-5">
              <div className="overflow-hidden rounded-2xl shadow-soft">
                <img
                  src="https://readdy.ai/api/search-image?query=a%20group%20of%20friendly%20diverse%20people%20gathered%20around%20a%20big%20watermelon%20discussing%20with%20speech%20bubbles%2C%20flat%20editorial%20illustration%2C%20warm%20cream%20background%2C%20green%20and%20coral%20color%20palette%2C%20community%20and%20open%20discussion%20theme%2C%20no%20text&width=640&height=520&seq=about-illustration&orientation=portrait"
                  alt="本月大瓜社区讨论氛围插画"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft">
                <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <i className="ri-quill-pen-line text-primary-600" /> 内容三条底线
                </p>
                <ul className="mt-3 flex flex-col gap-3 text-sm text-foreground-700">
                  {PRINCIPLES.map((p) => (
                    <li key={p.title} className="flex gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className={`${p.icon} text-sm`} />
                      </span>
                      <span>
                        <strong className="font-semibold text-foreground-900">{p.title}</strong> · {p.text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}